import { recordTestInstance } from '../axios';

const getLocationList = () =>
  recordTestInstance.get('/location/list');

export default getLocationList;
